module.exports = __webpack_public_path__ + "static/media/fight-background.97873eb4.mp3";